// import CloseIcon from "@mui/icons-material/Close";
import { Box, styled, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
// import AppBarCustom from "./AppBarCustom";
import FixBottomButton from "./FixBottomButton";
import imageWelcome from "../../../assets/images/welcome.png";
import { useRouter } from "../../../utils/hooks/useRouter";
import { RetailContext } from "../../../contexts/retail/retailMain.context";
import { firebaseAndKvaLog } from "../../../services/analytics/analytic.service";
import { IconCheckedWelcome } from "../../Static/Icons/Icon";
import React from "react";

const DomUrlWebsite = styled("div")({
  display: "flex",
  alignItems: "start",
  padding: "16px",
  border: "1px solid #E5E7E9",
  marginTop: "24px",
  borderRadius: "12px",
  "> div:nth-of-type(2)": {
    fontSize: "14px",
    lineHeight: "20px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginLeft: "8px",
    "> div:nth-of-type(2)": {
      color: "#0090DA !important",
      fontSize: "16px",
      fontWeight: "600",
      lineHeight: "24px",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
});

export default function ActiveDone() {
  const router = useRouter();
  const { merchantInfo } = useContext(RetailContext);
  const [link, setLink] = useState("https://www.mykiot.vn/");
  const [namespace] = useState(merchantInfo?.ref_id || "namespace");

  useEffect(() => {
    setLink(`${process.env.REACT_APP_THEME_IFRAME}/retail/${namespace}`);
  }, [namespace]);

  const openMyWebsite = (link: string) => {
    firebaseAndKvaLog(router.query.platform, "kvapp_mk_setup_linkweb");
    if ((window as any).isWeb()) {
      window.open(link);
    } else {
      (window as any).openMyWebsite(link, "retail");
    }
  };

  // const goBackSuperApp = () => {
  //   firebaseAndKvaLog(router.query.platform, "mk_cancel");
  //   (window as any).goBackSuperApp("retail");
  // };

  return (
    <Box
      sx={{
        maxWidth: "414px",
        padding: "20px 14px 100px 14px",
        width: "100%",
      }}
    >
      <div>
        <img src={imageWelcome} width={"100%"} />
        <Typography
          variant="h2"
          color="text.secondary"
          sx={{
            color: "#28A745",
            fontWeight: 700,
            fontSize: "24px",
            lineHeight: "32px",
            textAlign: "center",
            marginTop: "16px",
          }}
        >
          Kích hoạt cửa hàng online
          <br />
          thành công
        </Typography>
        <Typography
          color="text.secondary"
          sx={{
            color: "#323741",
            fontSize: "14px",
            lineHeight: "24px",
            textAlign: "center",
            marginTop: "14px",
          }}
        >
          Chào mừng bạn đến với <b>Kiotviet</b>, bạn đã hoàn thành việc tạo cửa
          hàng online. Nơi giúp bạn mở rộng kênh bán hàng, tăng doanh số và
          quảng cáo cửa hàng. Chia sẻ cửa hàng để bán hàng ngay bây giờ.
        </Typography>
        <DomUrlWebsite>
          <div>
            <IconCheckedWelcome />
          </div>
          <div>
            <div>Địa chỉ website của bạn</div>
            <div onClick={() => openMyWebsite(link)}>{link}</div>
          </div>
        </DomUrlWebsite>
        <FixBottomButton />
      </div>
    </Box>
  );
}
